<template>
  <section class="wrapper-content bg-error fill-height">
    <v-row align="center" justify="center" class="fill-height">
      <v-col cols="10">
        <v-row align="center" justify="center">
          <v-col cols="12" md="6">
            <v-card class="rounded-lg" color="#f1f1f1">
              <v-toolbar color="#374850" flat>
                <v-toolbar-title>
                  <v-icon size="20" class="mx-2" color="#ea5553"
                    >mdi-checkbox-blank-circle</v-icon
                  >
                  <v-icon size="20" class="mx-2" color="#f8d314"
                    >mdi-checkbox-blank-circle</v-icon
                  >
                  <v-icon size="20" class="mx-2" color="#62c36a"
                    >mdi-checkbox-blank-circle</v-icon
                  >
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-container>
                  <v-row align="center" justify="center">
                    <v-col cols="10">
                      <v-row align="center" justify="center">
                        <v-col class="text-center">
                          <v-icon color="#ea5553" size="100"
                            >fas fa-plug</v-icon
                          >
                        </v-col>
                        <v-col>
                          <h1 class="font-weight-black text-center text-404">
                            401
                          </h1>
                        </v-col>
                      </v-row>
                      <v-row align="center" justify="center">
                        <v-col>
                          <p class="text-center text-paragraph">
                            Al parecer no tienes los permisos para acceder al recurso o función
                          </p>
                          <p class="text-center text-paragraph">
                            Verifica tus permisos o haz click en
                            <span class="font-weight-bold">Regresar</span>
                          </p>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-row align="center" justify="center" class="my-2">
                  <v-col cols="6" class="text-center">
                    <v-btn
                      rounded
                      color="#ea5553"
                      class="white--text"
                      @click="back()"
                    >
                      Regresar
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </section>
</template>

<script type="JS">
import { LoginRequest } from "@/core/request";
import { mapActions } from "vuex";
import decode from "jwt-decode";

export default {
  name: "nofun",
  computed: {},
  data: () => ({}),
  methods: {
    ...mapActions(["logout"]),
    back() {
      this.logout();
    },
    /*back() {
      this.$router.push({name:"login"});
    },*/
  },
};
</script>
<style scoped>
.bg-login {
  background-image: url("../assets/suim_background.png");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: #464646;
}
.img-fluid {
  max-width: 100%;
  height: auto;
}
</style>
